/**
 * Gift With Purchase slider.
 *
 * Only ever does anything when a [data-gwp-slider] element is present, which
 * the theme renders solely when two or more gift slots are live. A single gift
 * renders a static box with no slider markup, so this is a no-op there.
 */
function initGwpSlider(root) {
  // The theme editor fires shopify:section:load repeatedly; without this guard
  // every reload would bind another set of click and scroll handlers.
  if (root.dataset.gwpInit === 'true') return;

  var track = root.querySelector('[data-gwp-track]');
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gwp-dot]'));
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gwp-slide]'));

  if (!track || slides.length < 2 || dots.length !== slides.length) return;

  root.dataset.gwpInit = 'true';

  var current = 0;

  function setCurrent(index) {
    current = index;
    for (var i = 0; i < dots.length; i++) {
      if (i === index) {
        dots[i].setAttribute('aria-current', 'true');
      } else {
        dots[i].removeAttribute('aria-current');
      }
    }
  }

  function place(index, offset) {
    // The slide width is the track's own width: slides are flex: 0 0 100%.
    var base = -index * track.clientWidth;
    track.style.transform = 'translateX(' + (base + (offset || 0)) + 'px)';
  }

  function goTo(index) {
    setCurrent(index);
    place(index, 0);
  }

  dots.forEach(function (dot, index) {
    dot.addEventListener('click', function () {
      goTo(index);
    });
  });

  // Arrows wrap rather than disable at the ends: with only two or three gifts a
  // dead arrow reads as broken, and the dots already show the position.
  var prev = root.querySelector('[data-gwp-prev]');
  var next = root.querySelector('[data-gwp-next]');

  if (prev) {
    prev.addEventListener('click', function () {
      goTo((current - 1 + slides.length) % slides.length);
    });
  }

  if (next) {
    next.addEventListener('click', function () {
      goTo((current + 1) % slides.length);
    });
  }

  // Drag / swipe, replacing the gesture the native scroll track used to give us.
  // Horizontal intent has to beat vertical before we capture, or the slider
  // steals page scrolling on touch.
  var down = null;

  track.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    down = { x: e.clientX, y: e.clientY, locked: false };
  });

  track.addEventListener('pointermove', function (e) {
    if (!down) return;
    var dx = e.clientX - down.x;

    if (!down.locked) {
      if (Math.abs(dx) < 6) return;
      if (Math.abs(dx) < Math.abs(e.clientY - down.y)) { down = null; return; }
      down.locked = true;
      root.classList.add('is-dragging');
      if (track.setPointerCapture) track.setPointerCapture(e.pointerId);
    }

    place(current, dx);
  });

  function endDrag(e) {
    if (!down) return;
    var dx = down.locked ? e.clientX - down.x : 0;
    root.classList.remove('is-dragging');
    down = null;

    var threshold = Math.min(70, track.clientWidth * 0.18);
    if (dx <= -threshold) {
      goTo((current + 1) % slides.length);
    } else if (dx >= threshold) {
      goTo((current - 1 + slides.length) % slides.length);
    } else {
      place(current, 0);
    }
  }

  track.addEventListener('pointerup', endDrag);
  track.addEventListener('pointercancel', endDrag);

  // The offset is in pixels, so it has to be recomputed when the track resizes.
  window.addEventListener('resize', function () { place(current, 0); });

  place(0, 0);
}

function initAllGwpSliders() {
  var roots = document.querySelectorAll('[data-gwp-slider]');
  for (var i = 0; i < roots.length; i++) initGwpSlider(roots[i]);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllGwpSliders);
} else {
  initAllGwpSliders();
}

// Re-init when the theme editor swaps a section.
document.addEventListener('shopify:section:load', initAllGwpSliders);
